import Client from 'requests/client';

const client = new Client({
  basePath: '/users/password',
  dataType: false,
});

export const changePasswordRequest = async data => {
  return client.update({ method: 'PUT', data });
};
